import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setIsAuthenticated, setLoading, setUser } from '../features/userSlice';
import { userApi } from '../api/userApi'
import toast from "react-hot-toast"
import { baseQueryWithCsrf } from "./baseQueryWithCsrf";

export const driverApi = createApi({
reducerPath: 'driverApi',
baseQuery: baseQueryWithCsrf,
tagTypes: ["DriverBookings", ],
endpoints: (builder) => ({

  driverRegister: builder.mutation({
    query(body) {
        return {
            url: "/driver/register",
            method: "POST",
            body,
        }
    },
    async onQueryStarted(args, {dispatch, queryFulfilled,}){
        try {
         await queryFulfilled
         await dispatch(userApi.endpoints.getMe.initiate(null))
         toast.success(" آپ کے واٹس ایپ پر بھیج دیا گیا۔ OTP", {
            duration: 20000, 
          });
} catch (error) {
            console.log(error);
        }
    },
}),  


login: builder.mutation({
  query(body) {
      return {
          url: "/driver/login",
          method: "POST",
          body,
      }
  },
  async onQueryStarted(args, {dispatch, queryFulfilled,}){
      try {
       await queryFulfilled
       await dispatch(userApi.endpoints.getMe.initiate(null))
       toast.success("کامیابی سے لاگ ان ہو گیا۔")
      } catch (error) {
          console.log(error);
      }
  }
}),

uploadAvatar: builder.mutation({
  query: (data) => ({
      url: '/driver/uploadAvatar',
      method: 'PUT',
      body: data,
  }),
}),

uploadCNIC: builder.mutation({
  query: (data) => ({
      url: '/driver/uploadCNIC',
      method: 'PUT',
      body: data,
  }),
}),

uploadDrivingLicense: builder.mutation({
  query(body) {
    return{
      url: "/driver/uploadDrivingLicense",
      method: "PUT",
      body,
    };
  }, 
}),


uploadVehicleRegistration: builder.mutation({
  query(body) {
    return{
      url: "/driver/uploadVehicleRegistration",
      method: "PUT",
      body,
    };
  }, 
}),

getDriverBookings: builder.query({
  query: () => `/driver/bookings`,
  providesTags: ["DriverBookings"],
}),

getOrderDetailsDriver: builder.query({
  query: (id) => `/driver/bookings/${id}`,
  providesTags: (result, error, id) => [{ type: 'Order', id }],
}),

updateDriverOrder: builder.mutation({
  query({ id, body }) {
    return {
      url: `/driver/bookings/adminProposedAmount/${id}`,
      method: "PUT",
      body,
    };
  },
  invalidatesTags: ["Order"],
}),

acceptDriverBooking: builder.mutation({
  query({ id, body }) {
    return {
      url: `/driver/bookings/${id}`,
      method: "PUT",
      body,  
      headers: {
        "Content-Type": "application/json",
      },
    };
  },
  invalidatesTags: ["Order"],
}),

updateDriverStatus: builder.mutation({
  query({ id, body }) {
    return {
      url: `/driver/booking/${id}`,
      method: "PUT",
      body,
    };
  },
  invalidatesTags: ["Order"],
}),

myOrdersDriver: builder.query({
  query: () => `/driver/mybookings`,
}),
 

    getDriverPaymentHistory: builder.query({
  query: () => '/driver/payment',
}),

addDriverPayment: builder.mutation({
  query: (paymentData) => ({
    url: '/driver/payment/pay',
    method: 'POST',
    body: {
      totalEarned: paymentData.totalEarned,
      mbzCut: paymentData.mbzCut,
      driversCut: paymentData.driversCut,
      msisdn: paymentData.msisdn,     // customer mobile
      cnic: paymentData.cnic          // customer CNIC
    },
  }),
}),



}),
});


export const { 
    useAddDriverPaymentMutation,
    useDriverRegisterMutation,
    useLoginMutation,
    useUploadCNICMutation,
    useUploadDrivingLicenseMutation,
    useUploadVehicleRegistrationMutation,
    useUploadAvatarMutation,
    useGetDriverBookingsQuery,
    useGetOrderDetailsDriverQuery,
    useUpdateDriverOrderMutation,
    useAcceptDriverBookingMutation,
    useUpdateDriverStatusMutation,
    useMyOrdersDriverQuery,
    useGetDriverPaymentHistoryQuery
  } = driverApi;